import type { Step } from './types';
import type { Edition } from '../calculator/types';

export const STEP_ORDER: Step[] = ['usage', 'needs', 'estimate', 'allowance', 'summary'];

export const EDITION_KEYS: Edition[] = ['free', 'standard', 'premium', 'enterprise'];
